/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Actuator_Operating_HoursInputs */



/**
* | output |
* | --- |
* | "Operating hours" |
*
* @param {Air_Handler_Unit_Actuator_Operating_HoursInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_actuator_operating_hours = /** @type {((inputs?: Air_Handler_Unit_Actuator_Operating_HoursInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Actuator_Operating_HoursInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Operating hours")
	return /** @type {LocalizedString} */ ("Temps de fonctionnement")
});